import React from 'react'
import { useNavigate } from 'react-router-dom'
import "./eachnews.css"

export default function EachNews(props) {
    const navigate = useNavigate();
  return (
    <div className='emas__eachnews' onClick={() => navigate(`../${props.page}`)}>
        <div className='emas__eachnews-content'>
            <div className='emas__eachnews-content_heading'>
                <h1>{props.title}</h1>
                <i>{props.date}</i>
            </div>
            <div className='emas__eachnews-content_description'>
                <p>{props.description}</p>
            </div>
        </div>
        <div className="emas__eachnews-image">
            <img src={`../assets/images/articles/${props.coverImg}`} alt='coverImg' />
            {/* <button>Continue reading...</button> */}
        </div>
    </div>
  )
}
